import styled from 'styled-components';
import { Icon, Typography } from '@web-chat-core/ui-kit';

export const DayPickerWrapper = styled.div`
    background: ${props => props.theme.root.colors.background['02Second']};
    z-index: 100 !important;
    border-radius: 8px;
    padding: 8px 12px 12px;

    .rdp-nav {
        align-items: center;
        display: flex;
        inset-block-start: 0;
        inset-inline-end: 0;
        position: absolute;

        .rdp-button_next {
            margin-left: 16px;
        }
    }

    .rdp-months {
        display: flex;
        flex-wrap: wrap;
        max-width: fit-content;
        position: relative;
    }

    .rdp-weekdays {
        color: ${props => props.theme.root.colors.basicColors['50%']};
    }

    .rdp-weekday {
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0.15px;
    }

    .rdp-day {
        letter-spacing: 0.25px;
        border-radius: 50%;
        &:hover {
            background: ${props => props.theme.root.colors.primary['20%']};
        }
        div {
            color: ${props => props.theme.root.colors.basicColors['90%']};
        }
    }

    .rdp-today {
        outline: 1px solid ${props => props.theme.root.colors.primary.default};
        div {
            color: ${props => props.theme.root.colors.primary.default};
        }
    }

    .rdp-focused {
    }

    .rdp-selected,
    .rdp-selected:hover {
        background: ${props => props.theme.root.colors.primary.default};
        div {
            color: ${props => props.theme.root.colors.basicColors['90%']};
        }
    }

    .rdp-hidden {
    }

    .rdp-disabled {
        background: transparent;
        &:hover {
            background: transparent;
        }
        div {
            color: ${props => props.theme.root.colors.basicColors['25%']};
        }
    }
`;

export const Day = styled(Typography)`
    cursor: pointer;
    height: 32px;
    width: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Caption = styled(Typography)`
    text-transform: capitalize;
    margin-left: 12px;
    margin-bottom: 16px;
    margin-top: 8px;
`;

export const ChevronButton = styled(Icon)<{ flip?: boolean }>`
    align-items: center;
    appearance: none;
    display: inline-flex;
    justify-content: center;
    margin: 0;
    padding: 0;
    position: relative;
    cursor: pointer;
    background: transparent;
    width: 24px;
    height: 24px;

    ${props => (props.flip ? 'transform: scaleX(-1)' : '')}
`;
